module.exports = __webpack_public_path__ + "img/icon-npay-m.5a64d5da.svg";